// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 40px 20px 20px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
}
.wrapper .cross-icon {
  z-index: 5;
  position: absolute;
  top: 20px;
  right: 20px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 22px;
  height: 22px;
  padding: 0px;
  z-index: 99;
}
.wrapper .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper ion-img {
  height: 70px;
  margin-bottom: 20px;
}
.wrapper h3 {
  padding: 15px;
  text-transform: capitalize;
  font-size: 36px;
  font-weight: 700;
}
.wrapper p {
  padding: 10px;
}
.wrapper ion-input {
  border: 1px solid #919191;
  border-radius: 6px;
  margin-bottom: 20px;
  --padding-start: 15px;
  text-transform: capitalize;
  --padding-top: 5px;
  min-height: 50px;
}
.wrapper ion-button {
  font-family: var(--ion-font-family);
  width: 100%;
  --border-width: 0px;
  padding: 4px;
}
.wrapper ion-button span {
  padding-top: 4px;
  text-transform: capitalize;
}
.wrapper .btn-outline-borderless-eintracht span {
  font-family: AppFontEintrachtOFCSans, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 130%;
}

.error-message {
  color: #b30101;
  padding: 10px;
  font-size: 12px;
}

.wrapper_for_types {
  height: 42px;
  width: 70%;
  background: #f6f1ef;
  border-radius: var(--border-radius-default);
  padding: 10px;
  margin: 0 auto 27px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.wrapper_for_types .item {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: color 1s ease-in-out;
}
.wrapper_for_types .item p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 20.2px;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-black-alt);
  position: relative;
  z-index: 1;
}
.wrapper_for_types .item.active p, .wrapper_for_types .item.active span {
  color: var(--color-white);
}
.wrapper_for_types .selector {
  position: absolute;
  left: 3%;
  top: 50%;
  width: 49%;
  height: 96%;
  transform: translate(-5%, -50%);
  border-radius: var(--border-radius-default);
  background: var(--ion-color-primary);
  transition: left 0.5s ease-in-out;
}
.wrapper_for_types .selector.second-position {
  left: 55%;
}

.dark-theme {
  background-color: #282828 !important;
}

.title {
  font-weight: 700;
  font-size: 30px;
  font-family: var(--ion-font-family);
  color: #000;
  text-transform: capitalize;
}

.title-dark {
  color: #fff;
  text-transform: uppercase;
  font-family: EintrachtDisplay, sans-serif;
  font-weight: 400;
}

.input {
  margin-top: 2rem;
}

.dark-input {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/add-gift-card-dialog/add-gift-card-dialog.component.scss"],"names":[],"mappings":"AACA;EACI,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;AACI;EACF,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACF;AAAE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAEH;AACI;EACI,YAAA;EACA,mBAAA;AACR;AACI;EACI,aAAA;EACN,0BAAA;EACA,eAAA;EACG,gBAAA;AACL;AACI;EACI,aAAA;AACR;AACI;EACI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACN,qBAAA;EACG,0BAAA;EACH,kBAAA;EACG,gBAAA;AACL;AACI;EACF,mCAAA;EACM,WAAA;EACN,mBAAA;EACA,YAAA;AACF;AAAE;EACC,gBAAA;EACA,0BAAA;AAEH;AAEE;EACC,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAH;;AAKA;EACI,cAAA;EACA,aAAA;EACA,eAAA;AAFJ;;AAIA;EAEC,YAAA;EACA,UAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EAEA,aAAA;EACA,8BAAA;EACA,kBAAA;AAHD;AAMC;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;AAJF;AAKE;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;AAHH;AAMG;EACC,yBAAA;AAJJ;AASI;EACF,kBAAA;EACA,QAAA;EACE,QAAA;EACA,UAAA;EACA,WAAA;EAEF,+BAAA;EACA,2CAAA;EACA,oCAAA;EACA,iCAAA;AARF;AAUE;EACC,SAAA;AARH;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,WAAA;EACA,0BAAA;AATF;;AAYA;EACE,WAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,WAAA;AATF","sourcesContent":["\n.wrapper {\n    padding: 40px 20px 20px;\n    position: relative;\n    text-align: center;\n    text-transform: uppercase;\n    .cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tright: 20px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t}\n    ion-img {\n        height: 70px;\n        margin-bottom: 20px;\n    }\n    h3 {\n        padding: 15px;\n\t\ttext-transform: capitalize;\n\t\tfont-size: 36px;\n    \tfont-weight: 700;\n    }\n    p {\n        padding: 10px;\n    }\n    ion-input {\n        border: 1px solid #919191;\n        border-radius: 6px;\n        margin-bottom: 20px;\n\t\t--padding-start: 15px;\n    \ttext-transform: capitalize;\n\t\t--padding-top: 5px;\n    \tmin-height: 50px;\n    }\n    ion-button {\n\t\tfont-family: var(--ion-font-family);\n        width: 100%;\n\t\t--border-width: 0px;\n\t\tpadding: 4px;\n\t\tspan {\n\t\t\tpadding-top: 4px;\n\t\t\ttext-transform: capitalize;\n\t\t}\n    }\n\t.btn-outline-borderless-eintracht {\n\t\tspan {\n\t\t\tfont-family: AppFontEintrachtOFCSans, sans-serif;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 130%;\n\t\t}\n\t}\n\t\n}\n.error-message {\n    color: #b30101;\n    padding: 10px;\n    font-size: 12px;\n}\n.wrapper_for_types {\n\n\theight: 42px;\n\twidth: 70%;\n\tbackground: #f6f1ef;\n\tborder-radius: var(--border-radius-default);\n\tpadding: 10px;\n\tmargin: 0 auto 27px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tposition: relative;\n\n\n\t.item {\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition: color 1s ease-in-out;\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 20.2px;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--color-black-alt);\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\t\t}\n\t\t&.active {\n\t\t\tp, span {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n\n    .selector {\n\t\tposition: absolute;\n\t\tleft: 3%;\n    top: 50%;\n    width: 49%;\n    height: 96%;\n\n\t\ttransform: translate(-5%, -50%);\n\t\tborder-radius: var(--border-radius-default);\n\t\tbackground: var(--ion-color-primary);\n\t\ttransition: left 0.5s ease-in-out;\n\n\t\t&.second-position {\n\t\t\tleft: 55%;\n\t\t}\n\t}\n}\n.dark-theme {\n  background-color: #282828 !important;\n}\n\n.title {\n  font-weight: 700;\n  font-size: 30px;\n  font-family: var(--ion-font-family);\n  color: #000;\n  text-transform: capitalize;\n}\n\n.title-dark {\n  color: #fff;\n  text-transform: uppercase;\n  font-family: EintrachtDisplay, sans-serif;\n  font-weight: 400;\n}\n\n.input {\n  margin-top: 2rem;\n}\n\n.dark-input {\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
